var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTensionArterial(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 33,
    height: 22.212,
    viewBox: "0 0 33 22.212",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_12379",
    "data-name": "Group 12379",
    transform: "translate(-667.664 -219.26)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12176",
    "data-name": "Group 12176",
    transform: "translate(668.164 219.764)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union_11",
    "data-name": "Union 11",
    d: "M12.678,20.9A43.756,43.756,0,0,1,4.06,14.528a19.332,19.332,0,0,1-2.291-2.666h.387c1.57,0,3.146-.011,4.716.006A1.078,1.078,0,0,0,8,11.13c.24-.6.51-1.179.8-1.835.228.807.433,1.547.639,2.292.187.695.381,1.405.574,2.1a.982.982,0,0,0,.9.826,1,1,0,0,0,.967-.71c.516-1.211,1.025-2.43,1.553-3.643.041-.1.17-.234.258-.234,2.185-.017,4.371-.011,6.6-.011-.053.094-.088.165-.129.229a7.515,7.515,0,0,0-.9,7.545c.07.178.064.276-.1.381-1.441.936-2.865,1.893-4.318,2.806a2.018,2.018,0,0,1-1.087.33A2.133,2.133,0,0,1,12.678,20.9Zm13.58-.456a5.736,5.736,0,1,1,.011,0Zm1.7-8.864a17.82,17.82,0,0,0-3.41,1.067,2.688,2.688,0,0,0-1.494,2.43c.018.165.018.3.041.428a2.808,2.808,0,0,0,2.5,2.386A2.649,2.649,0,0,0,28.4,16.2c.4-1.037.65-2.127.967-3.193.286-.985-.2-1.5-.929-1.5A1.859,1.859,0,0,0,27.958,11.575ZM10.692,9.1c-.252-.914-.5-1.826-.75-2.734A.946.946,0,0,0,8.1,6.226c-.51,1.16-1.025,2.319-1.523,3.486a.383.383,0,0,1-.41.281C4.435,9.98,2.7,9.98.972,9.993c-.24,0-.363-.077-.422-.3C.375,9.031.187,8.376,0,7.714V6.466C.105,6.009.176,5.547.3,5.1a7.059,7.059,0,0,1,13.282-.773c.047.107.094.2.164.369A7.089,7.089,0,0,1,17.494.654,6.846,6.846,0,0,1,22.931.478,6.967,6.967,0,0,1,27.477,7.14a2.517,2.517,0,0,1-.293,0,7.638,7.638,0,0,0-4.447.8,1.03,1.03,0,0,1-.48.094q-4.552.006-9.093,0c-.726,0-.943.148-1.23.821-.252.593-.5,1.184-.791,1.85C10.979,10.128,10.839,9.611,10.692,9.1Z",
    transform: "translate(0 0)",
    fill: "#3177be",
    stroke: "rgba(0,0,0,0)",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6786",
    "data-name": "Path 6786",
    d: "M1009.817,1995.765c-.194.513-.369,1.035-.589,1.537a.661.661,0,0,1-.726.287.759.759,0,0,1-.607-.632.666.666,0,0,1,.341-.726c.485-.2.987-.369,1.482-.55Z",
    transform: "translate(-982.701 -1981.707)",
    fill: "#3177be"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTensionArterial);
export default __webpack_public_path__ + "static/media/Tension_arterial.82589a64792e9bca2b23a49d6b37fb84.svg";
export { ForwardRef as ReactComponent };